import { render, staticRenderFns } from "./weixinlogin.vue?vue&type=template&id=abd33b0c&scoped=true&"
import script from "./weixinlogin.vue?vue&type=script&lang=js&"
export * from "./weixinlogin.vue?vue&type=script&lang=js&"
import style0 from "./weixinlogin.vue?vue&type=style&index=0&id=abd33b0c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abd33b0c",
  null
  
)

export default component.exports